import { room,Video,CONV_STORAGE, bottomAction, onStage, kinoControls, permissions, socket } from '../libs/roomnew';
export default class LockFocus {
    constructor(){
        this.btnLabel = `Spaces Lock`;
        this.btn = null;
        this.btnSwitch = null;
        this.locked = false;

        //icons
        this.lockFocusIcon = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 24C6 33.9 14.1 42 24 42C33.9 42 42 33.9 42 24C42 14.1 33.9 6 24 6C14.1 6 6 14.1 6 24ZM10 24C10 16.3 16.3 10 24 10C31.7 10 38 16.3 38 24C38 31.7 31.7 38 24 38C16.3 38 10 31.7 10 24Z" fill="black"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22 3H26V13H22V3ZM3 22H13V26H3V22ZM45 22H35V26H45V22ZM26 35H22V45H26V35Z" fill="#78909C"/>
        <path d="M28.2857 21.1429V20.2857C28.2857 17.92 26.3657 16 24 16C21.6343 16 19.7143 17.92 19.7143 20.2857V21.1429C18.7714 21.1429 18 21.9143 18 22.8571V29.7143C18 30.6571 18.7714 31.4286 19.7143 31.4286H28.2857C29.2286 31.4286 30 30.6571 30 29.7143V22.8571C30 21.9143 29.2286 21.1429 28.2857 21.1429ZM26.5714 21.1429H21.4286V20.2857C21.4286 18.8629 22.5771 17.7143 24 17.7143C25.4229 17.7143 26.5714 18.8629 26.5714 20.2857V21.1429Z" fill="black"/>
        </svg>`;
        this.lockFocusIconNotification = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 24C6 33.9 14.1 42 24 42C33.9 42 42 33.9 42 24C42 14.1 33.9 6 24 6C14.1 6 6 14.1 6 24ZM10 24C10 16.3 16.3 10 24 10C31.7 10 38 16.3 38 24C38 31.7 31.7 38 24 38C16.3 38 10 31.7 10 24Z" fill="#e0e4e5"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22 3H26V13H22V3ZM3 22H13V26H3V22ZM45 22H35V26H45V22ZM26 35H22V45H26V35Z" fill="#78909C"/>
        <path d="M28.2857 21.1429V20.2857C28.2857 17.92 26.3657 16 24 16C21.6343 16 19.7143 17.92 19.7143 20.2857V21.1429C18.7714 21.1429 18 21.9143 18 22.8571V29.7143C18 30.6571 18.7714 31.4286 19.7143 31.4286H28.2857C29.2286 31.4286 30 30.6571 30 29.7143V22.8571C30 21.9143 29.2286 21.1429 28.2857 21.1429ZM26.5714 21.1429H21.4286V20.2857C21.4286 18.8629 22.5771 17.7143 24 17.7143C25.4229 17.7143 26.5714 18.8629 26.5714 20.2857V21.1429Z" fill="#e0e4e5"/>
        </svg>`;
        this.focusedIcon = `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px">
        <path fill="#e0e4e5" d="M12,2c-4.2,0-8,3.22-8,8.2c0,3.18,2.45,6.92,7.34,11.22c0.36,0.32,0.97,0.32,1.33,0C17.55,17.12,20,13.38,20,10.2 C20,5.22,16.2,2,12,2z M7.69,12.49C8.88,11.56,10.37,11,12,11s3.12,0.56,4.31,1.49C15.45,13.98,13.85,15,12,15 S8.55,13.98,7.69,12.49z M12,6c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C10,6.9,10.9,6,12,6z"/>
        </svg>`;
        // this.focusedIcon = `<svg width="61" height="62" viewBox="0 0 61 62" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 1.51578C14.267 3.24878 14.1144 5.51578 14.1144 14.0158C14.1144 29.0158 13 28.0158 30.1144 28.0158C47.0857 28.0158 46 29.0158 46 14.0158C46 -0.484222 47 0.0157758 30.1144 0.0157758C19.4474 0.0157758 17.778 -0.262222 16 1.51578ZM34.5 6.51578C36.464 8.29278 36.5 13.5 35 14.5C34.5 14.8333 34.8614 16.1498 36.0964 17.7208C38.1864 20.3768 38.8134 24.0158 37.1814 24.0158C36.6684 24.0158 35.9594 23.1038 35.6064 21.9888C34 15.5158 26.1038 15.5158 24.3774 22.1178C24.1044 23.1618 23.4834 24.0158 22.9974 24.0158C21.4084 24.0158 22.0704 20.3418 24.1324 17.7208C25.3674 16.1498 25.5 15 25.1324 14.5268C23.5474 13.5468 23.9354 8.87178 25.7694 6.84478C27.8304 4.56778 32.085 4.32978 34.5 6.51578ZM27.6854 8.58678C25.4563 10.7266 26.5 15.0158 30.1144 15.0158C33.7288 15.0158 34 12.1268 34 11.0158C34 7.93078 29.5 6.84478 27.6854 8.58678ZM5 36.0158C1.865 39.1508 2.20038 41.5158 3.20038 45.1758C4.07538 46.8118 3.88238 47.6338 2.20038 49.4248C-0.00962019 51.7768 -0.87462 61.0158 1.11438 61.0158C1.66438 61.0158 2.11438 59.6458 2.11438 57.9708C2.11438 53.9058 6.02638 50.0158 10.1144 50.0158C14.2024 50.0158 18.1144 53.9058 18.1144 57.9708C18.1144 60.3488 18.5524 61.0158 20.1144 61.0158C21.6764 61.0158 22.1144 60.3488 22.1144 57.9708C22.1144 53.9058 26.0264 50.0158 30.1144 50.0158C34.2024 50.0158 38.1144 53.9058 38.1144 57.9708C38.1144 60.5158 38.5524 61.0158 40.1144 61.0158C41.6764 61.0158 42.1144 60.3488 42.1144 57.9708C42.1144 53.9058 46.0264 50.0158 50.1144 50.0158C54.2024 50.0158 58.1144 53.9058 58.1144 57.9708C58.1144 59.6458 58.5644 61.0158 59.1144 61.0158C61.0424 61.0158 60.2484 51.7878 58.1264 49.5288C56.4024 47.6928 56.2934 47.0018 57.3074 44.3148C59 38.5 53.0744 33 47.6674 34.8098C43.5084 36.7048 41.1144 41.5158 43.1144 45.5158C43.1144 50.0158 40.1144 51.0158 38.1164 49.4628C36.3734 47.7188 36.2694 47.0668 37.2974 44.3408C38.6864 40.6618 36.7204 36.7048 32.5614 34.8098C27 33 20.8024 38.7028 22.9314 44.3408C24.7094 49.0518 20.729 52.6538 17.5 49.4248C16 47.5158 15.6076 46.6681 16.5 45C18.788 40.723 15.0404 34.0158 10.1144 34.0158C8.92938 34.0158 6.608 34.4078 5 36.0158ZM13.0744 39.4678C15.7314 42.6688 12 47.6928 8.36438 45.4038C6.14238 44.0048 5.59938 41.3408 7.15438 39.4678C8.69838 37.6068 11.5304 37.6068 13.0744 39.4678ZM33.0744 39.4678C34.6294 41.3408 34 44.5 31.8644 45.4038C28.2031 46.9532 24.4974 42.6688 27.1544 39.4678C28.6984 37.6068 31.5304 37.6068 33.0744 39.4678ZM53.0744 39.4678C54.6294 41.3408 54.0864 44.0048 51.8644 45.4038C48.3994 47.5858 44.4974 42.6688 47.1544 39.4678C48.6984 37.6068 51.5304 37.6068 53.0744 39.4678Z" fill="#e0e4e5"/></svg>`;
    }

    events(){
        socket.events.SpacesLock=(message)=>{
            this.handleLockFocusMessage(message)
        }
    }


    addOptionButton() {
        var lf = this;
        try {
            const hasAccess=permissions.hasSpacesLock();
            if(!hasAccess && !permissions.isWorkspace){
                return
            }
            if(lf.isLocked()){
                lf.showUnlockFocusButton();
            }
            lf.btnSwitch = $('<label />', {
                class: 'switch',
                html: [`<input type="checkbox" id="lockFocus-checkbox" ${lf.isLocked() ? 'checked' : ''}><span class="kino-slider round"></span>`],
            // }).on('change', function () {
                // console.error('focus locked unlocked')
            });
            lf.optionIcon = $('<div/>', {
                class: "option-icon",
                id: "lockFocusIcon",
                html: lf.lockFocusIcon,
            });
            lf.optionName = $('<div/>', {
                class: "option-name",
                id: "option-name-lockFocus",
                html: lf.btnLabel,
            });
            lf.optionAction = $('<div/>', {
                class: "option-action pe-none kino-toggle",
                id: "option-action-lockFocus",
                html: lf.btnSwitch,
            });
            lf.optionDescription = $('<div/>', {
                class: "option-description",
                html: [ lf.optionName, lf.optionAction],
            });
            lf.btn = $('<span/>', {
                for: 'lockFocus-checkbox',
                class: `option ${!hasAccess ? 'feature-disabled' :'' }`,
                id: 'lockFocusBtn',
                html: [lf.optionIcon, lf.optionDescription],
            }).on('click',function(e){
                e.stopPropagation();
                if(!hasAccess){return}
                if(!lf.locked){
                    lf.startLockFocus(false);
                    return;
                }else{
                    lf.stopLockFocus(false);
                }
                console.log("Lock focus changed to",lf.locked)
            });
            if(!hasAccess){
                lf.btn.attr('data-toggle','tooltip')
                lf.btn.attr('data-placement','top')
                lf.btn.attr('data-original-title','This feature is disabled in this workspace.')
            }

            $("#option-list").append(lf.btn);
            kinoControls.registerControl('lock-focus',lf.lockFocusIcon,'Spaces Lock',"switch",lf.locked,(el)=>{
                if(!lf.locked){
                    lf.startLockFocus(false);
                    return;
                }else{
                    lf.stopLockFocus(false);
                }
            });
            //$("#kino-options-list").prepend(lf.btn);
        } catch (error) {
            console.error("Error adding lock focus button", error);
        }
    };

    removeOptionButton(){
        var lf=this;
        lf.btn=null;
        // lf.stealFocus.unlockFocusBtn();
        $("#option-list").find("#lockFocusBtn").remove();
        this.hideUnlockFocusButton();
    };

    startLockFocus(silent=true){
        let lf = this;
        // if(Video.stealFocus.participantFocused && !skipCheck){
        //     return;
        // }
        if(!permissions.hasSpacesLock()){return}
        try{
            lf.focusLockedEvent("You",silent);
            lf.sendLockFocusCommand(lf.locked,silent);
        }catch(err){
            console.error(err);
        }
    }

    stopLockFocus(silent=true, skipCheck=true){
        let lf = this;
        if(onStage.isActive()){
            onStage.showUnlockFocusDisabled();            
            return;
        }
        try{
            lf.focusUnlockedEvent("You",silent);
            lf.sendLockFocusCommand(lf.locked,silent);
        }catch(err){
            console.error(err);
        }
    }

    sendLockFocusCommand(lockFocus,silent=true){
        var lf=this;
        try{
            // room.broadcastEndpointMessage({
            //     lock_focus_message: "lock_focus_changed",
            //     data: {isLocked: lockFocus,silent:silent}
            // });
            socket.sendSpacesLockMessage(lockFocus,silent);
        }catch(err){
            console.error(err);
        }
    };

    isLocked(){
        if(permissions.isWorkspace){
            return this.locked && permissions.shouldLockSpaces();
        }else{
            return this.locked;
        }
    }
    isModerator(){
        return HOST==1 || ROLE=="moderator";
    };
    participantLeft(id){
        try {
            if(room && !permissions.isWorkspace){
                let participants=room.getParticipants();
                if(participants){
                    let can_unlock=participants.filter(p=>p.getProperty('can_unlock_focus') && p.getId() != id && Video.videos[p.getId()]);
                    console.log("Participants that can unlock focus",can_unlock);
                    if(can_unlock.length==0 && !this.isModerator()){
                        console.warn("Unlocking focus because no one left to unlock");
                        this.focusUnlockedEvent("",true);
                    }
                }
            }
        } catch (error) { console.error("[Kino Error] [lockFocus]", error); }
    };

    handleLockFocusMessage(message){
        var lf=this;
        let user_name = message.data.from_name;
        console.log(user_name + ' set lock focus to ', message.data.isLocked );
        $('#lockFocus-checkbox').prop("checked", message.data.isLocked);
        if(message.data.isLocked){
            this.focusLockedEvent(user_name,message.data.silent);
        }else{
            this.focusUnlockedEvent(user_name,message.data.silent);
        }
    }

    focusLockedEvent(from_name,silent=false){
        this.locked=true;
        permissions.isWorkspace && permissions.setSetting('lock_spaces',true)
        console.trace("focus locked event")
        if(permissions.hasSpacesLock()){
            if(this.btn && this.btnSwitch){
                $('#lockFocus-checkbox').prop("checked", true);
            }
            kinoControls.toggleSwitch('lock-focus',true);
            this.showUnlockFocusButton();
            !permissions.isWorkspace && room.setLocalParticipantProperty('can_unlock_focus',true);
        }
        silent || Video.showNotification(this.lockFocusIconNotification,`${from_name} locked the Spaces`,'lockFocusNotification', room.myUserId(), true);
    }

    focusUnlockedEvent(from_name,silent=false){
        this.locked=false;
        permissions.isWorkspace && permissions.setSetting('lock_spaces',false)
        if(permissions.hasSpacesLock()){
            if(this.btn && this.btnSwitch){
                $('#lockFocus-checkbox').prop("checked", false);
            }
            kinoControls.toggleSwitch('lock-focus',false);
            !permissions.isWorkspace && room.setLocalParticipantProperty('can_unlock_focus',null);
        }
        this.hideUnlockFocusButton();
        // silent || Video.showNotification(this.focusedIcon,`${from_name} unlocked everyone's focus.`,'lockFocusNotification', room.myUserId());
        silent || Video.showNotification(this.lockFocusIconNotification,`${from_name} unlocked the Spaces`,'lockFocusNotification', room.myUserId());
    }

    setSpacesLock(){
        
        if(permissions.hasSpacesLock()){
            if(this.btn && this.btnSwitch){
                $('#lockFocus-checkbox').prop("checked", this.locked);
            }
            kinoControls.toggleSwitch('lock-focus',this.locked);
            !permissions.isWorkspace && room.setLocalParticipantProperty('can_unlock_focus',null);
        }else if(permissions.isWorkspace){
            $('#lockFocus-checkbox').prop("checked", this.locked);
        }
    }
    checkLockFocusOnJoin(){
        try {
            if(room && !permissions.isWorkspace){
                let participants=room.getParticipants();
                if(participants){
                    let can_unlock=participants.filter(p=>p.getProperty('can_unlock_focus') && Video.videos[p.getId()]);
                    console.log("Participants that can unlock focus",can_unlock);
                    if(can_unlock.length > 0){
                        console.warn("Locking focus");
                        this.focusLockedEvent("",true);
                        Video.showNotification(this.lockFocusIconNotification,`Spaces are locked`,'lockFocusNotification', room.myUserId(), true);
                    }
                }
            }
        } catch (error) { console.error("[Kino Error] [lockFocus]", error); }
    };

    showUnlockFocusButton(){
        
    };

    hideUnlockFocusButton(){
        
    };

    updateUnlockButtonPosition(){
        // console.trace("Called update unlock button",this);
        if(bottomAction.actionShown('lock-focus') && this.locked){
            if(CONV_STORAGE.myConversation){
                if(CONV_STORAGE.bannerShown){
                    if(bottomAction.idsByContainer['lock-focus']=='lobby'){
                        bottomAction.moveToSpacesActions('lock-focus');
                    }
                }else{
                    console.trace("move to bottom actions",bottomAction.idsByContainer['lock-focus'])
                    if(bottomAction.idsByContainer['lock-focus']=='spaces'){
                        bottomAction.moveToBottomActions('lock-focus');
                    }
                }
            }else{
                if(bottomAction.idsByContainer['lock-focus']=='spaces'){
                    bottomAction.moveToBottomActions('lock-focus');
                }
            }
        }
    };
    showLockFocusNotification(){
        var sf=this;
        console.error("Focus is locked by moderators message");
        Video.showNotification(sf.lockFocusIconNotification,`Spaces are locked`,'lockFocusNotification',room.myUserId(),true);
    };

    checkIfUserCanBeFocused(participant_id){
        let sf = this;
        console.error("PARTICIPANT ROLE: ", room.getParticipantById(participant_id).getProperty("role"))
        if(sf.isLocked() && CONV_STORAGE.isModerator()){
            if(room.getParticipantById(participant_id).getProperty("role") != 'moderator'){
                sf.showLockFocusNotification();
            }else{
                sf.showLockFocusNotification(true);
            }
        }
        return;
    }


    disableLockFocusButton(){
        try {
            if(permissions.hasSpacesLock()){
                $("#lockFocusBtn").attr({
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "title":"Spaces can not be unlocked when Stage View is active",
                    "data-original-title": "Spaces can not be unlocked when Stage View is active"
                }).addClass("button-disabled"); 
                kinoControls.disableAction('lock-focus');
            }

        } catch (error) { console.error("[Kino Error] [lockFocus]", error); }
    };

    enableLockFocusButton(){
        try {
            if(!permissions.hasSpacesLock()){return}
            kinoControls.enableAction('lock-focus');
            if($("#lockFocusBtn")){
                $("#lockFocusBtn").removeAttr(
                    "data-toggle data-placement data-original-title title"
                ).removeClass("button-disabled"); 
            }
        } catch (error) { console.error("[Kino Error] [lockFocus]", error); }
    };
}